import React from 'react';
import { Carousel as AntCarousel, ConfigProvider } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styles from './index.scss';

interface CarouselProps {
  images: Array<{
    src: string;
    alt: string;
    link?: string;
  }>;
  interval?: number;
  showDots?: boolean;
  showArrows?: boolean;
}

const CustomArrow = ({
  type,
  className,
  onClick,
}: {
  type: 'prev' | 'next';
  className?: string;
  onClick?: () => void;
}) => (
  <div
    className={`slick-arrow ${className}`}
    onClick={onClick}
    style={{ display: 'block' }}
  >
    {type === 'prev' ? <LeftOutlined /> : <RightOutlined />}
  </div>
);

const Carousel: React.FC<CarouselProps> = ({
  images,
  interval = 3000,
  showDots = true,
  showArrows = true,
}) => {
  return (
    <div className={styles.carousel}>
      <ConfigProvider
        theme={{
          components: {
            Carousel: {
              arrowSize: 48,
            },
          },
        }}
      >
        <AntCarousel
          autoplay
          effect="fade"
          autoplaySpeed={interval}
          dots={showDots}
          arrows={showArrows}
          infinite={true}
          prevArrow={<CustomArrow type="prev" className={styles.prevArrow} />}
          nextArrow={<CustomArrow type="next" className={styles.nextArrow} />}
        >
          {images.map((image, index) => (
            <div key={index} className={styles.slide}>
              <div className={styles.imageWrapper}>
                <img
                  src={image.src}
                  alt={image.alt}
                  onClick={() =>
                    image.link && (window.location.href = image.link)
                  }
                  style={{ cursor: image.link ? 'pointer' : 'default' }}
                />
              </div>
            </div>
          ))}
        </AntCarousel>
      </ConfigProvider>
    </div>
  );
};

export default Carousel;
